import WebUI from "@tinqin/tinqin-web-ui";

export const load = async moduleName => {
    const feature = await getComponentModule(moduleName);
    const featureExports = feature.default;
    WebUI.addComponents(featureExports.components);
    if (featureExports.actions) {
        WebUI.addActions(featureExports.actions);
    }
    if (featureExports.sirenActionsMapping) {
        WebUI.addSirenActionsMapping(featureExports.sirenActionsMapping);
    }
};

const getComponentModule = async (module = "") => {
    if (module) {
        // console.log(`Requestion components for module: ${module}.`);
        let bundle;
        switch (module) {
            case "article":
                bundle = await import(/* webpackChunkName: `components.article` */ `./article`);
                break;
            case "event-calendar":
                bundle = await import(
                    /* webpackChunkName: `components.event-calendar` */ `./event-calendar`
                );
                break;
            case "faq-results":
                bundle = await import(
                    /* webpackChunkName: `components.faq-results` */ `./faq-results`
                );
                break;
            case "gallery":
                bundle = await import(/* webpackChunkName: `components.gallery` */ `./gallery`);
                break;
            case "HOC":
                bundle = await import(/* webpackChunkName: `components.HOC` */ `./HOC`);
                break;
            case "indicators":
                bundle = await import(
                    /* webpackChunkName: `components.indicators` */ `./indicators`
                );
                break;
            case "loading":
                bundle = await import(/* webpackChunkName: `components.loading` */ `./loading`);
                break;
            case "map":
                bundle = await import(/* webpackChunkName: `components.map` */ `./map`);
                break;
            case "results-list":
                bundle = await import(
                    /* webpackChunkName: `components.results-list` */ `./results-list`
                );
                break;
            case "reimbursement":
                bundle = await import(
                    /* webpackChunkName: `components.reimbursement` */ `./reimbursement`
                );
                break;
            case "slides":
                bundle = await import(/* webpackChunkName: `components.slides` */ `./slides`);
                break;
            case "smooth-resizing":
                bundle = await import(
                    /* webpackChunkName: `components.smooth-resizing` */ `./smooth-resizing`
                );
                break;
            case "social":
                bundle = await import(/* webpackChunkName: `components.social` */ `./social`);
                break;
            case "anchor":
                bundle = await import(/* webpackChunkName: `components.anchor` */ `./anchor`);
                break;
            case "iframe":
                bundle = await import(/* webpackChunkName: `components.iframe` */ `./iframe`);
                break;
            case "filters":
                bundle = await import(/* webpackChunkName: `components.filters` */ `./filters`);
                break;
            case "accordion-with-regions":
                bundle = await import(
                    /* webpackChunkName: `components.accordionWithRegions` */ `./accordion-with-regions`
                );
                break;
            case "experts":
                bundle = await import(/* webpackChunkName: `components.experts` */ `./experts`);
                break;
            case "profile":
                bundle = await import(/* webpackChunkName: `components.profile` */ `./profile`);
                break;
            case "autosuggest":
                bundle = await import(
                    /* webpackChunkName: `components.autosuggest` */ `./autosuggest`
                );
                break;
            case "community":
                bundle = await import(/* webpackChunkName: `components.community` */ `./community`);
                break;
            case "gmf":
                bundle = await import(/* webpackChunkName: `components.gmf` */ `./gmf`);
                break;
            case "summary-card":
                bundle = await import(
                    /* webpackChunkName: `components.summary-card` */ `./summary-card`
                );
                break;
            case "switcher-with-items-children":
                bundle = await import(
                    /* webpackChunkName: `components.switcher-with-items-children` */ `./switcher-with-items-children`
                );
                break;
            case "pagination":
                bundle = await import(
                    /* webpackChunkName: `components.pagination` */ `./pagination`
                );
                break;
            case "header-pf":
                bundle = await import(/* webpackChunkName: `components.header-pf` */ `./header-pf`);
                break;
            case "header":
                bundle = await import(/* webpackChunkName: `components.header` */ `./header`);
                break;
            default:
                WebUI.log("Unknown module");
                break;
        }
        if (bundle) {
            //Add components directly to webUi for testing
            WebUI.addComponents(bundle.default);
            return bundle;
        }
    } else {
        WebUI.log("Unkown module");
    }
};

export default { load };
